export const ACTION_ENABLE_USER = 'ACTION_ENABLE_USER';
export const ACTION_DISABLE_USER = 'ACTION_DISABLE_USER';

export const ACTION_SHOW_ENABLE_USER_DIALOG = 'ACTION_SHOW_ENABLE_USER_DIALOG';
export const ACTION_SHOW_DISABLE_USER_DIALOG = 'ACTION_SHOW_DISABLE_USER_DIALOG';
export const ACTION_HIDE_ENABLE_DISABLE_USER_DIALOG = 'ACTION_HIDE_ENABLE_DISABLE_USER_DIALOG';

